import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatButtonModule, MatCheckboxModule } from '@angular/material';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { ForgotPasswordFormComponent } from './forms/forgot-password-form.component';
import { LoginFormComponent } from './forms/login-form.component';
import { ResetPasswordFormComponent } from './forms/reset-password-form.component';
import { ConfirmPasswordResetComponent } from './forms/confirm-password-reset.component';
import { ConfirmEmailSentComponent } from './forms/confirm-email-sent.component';
import { LoginAuthGuard } from './login-auth-guard.service';
import { EstablishPasswordComponent } from './forms/establish-password.component';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    SharedModule
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordFormComponent,
    ResetPasswordFormComponent,
    LoginFormComponent,
    ConfirmEmailSentComponent,
    ConfirmPasswordResetComponent,
    EstablishPasswordComponent
  ],
  providers: [
    LoginAuthGuard
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts